import { IndexModel } from "../Support/IndexModel";
import { axios } from "../Support/Axios";
export class ReportCompleteIndex extends IndexModel {
    name = 'Complete Reports';
    endpoint = 'report/queue';
    export = false;
    pending = false;
    constructor(pending) {
        super();
        this.pending = pending;
        if (this.pending) {
            this.name = 'Pending Reports';
            this.endpoint = 'report/queue/pending';
        }
    }
    getData() {
        return super.getData();
    }
    getQueueExport(uuid) {
        const url = '/api/report/queue/export/' + uuid;
        return axios.get(url)
            .then((response) => this.export = response.data)
            .catch(e => this.setError(e));
    }
    resetQueueExport() {
        this.export = false;
    }
}
